module.exports = __webpack_public_path__ + "img/1986.5e93367a.jpg";